module.exports = __webpack_public_path__ + "img/be-kind-background.7a13238.jpg";